import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Flex, Box } from "grid-styled";
import Text from "../Text";
import { InputContainer, SalespersonSelect } from "../forms";
import { reduxForm, Field } from "redux-form";
import { Panel, PanelHeader, PanelBody } from "../Panel";
import UserInfo from "./UserInfo";
import Button from "../Button";

const ChangeSalespersonForm = reduxForm({
  form: "changeSalesperson"
})(({ handleSubmit, onCancel, franchiseId }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box pb={2}>
        <Field
          name="salespersonId"
          placeholder="e.g., Victor Sullivan"
          component={InputContainer}
          fieldComponent={SalespersonSelect}
          franchiseId={franchiseId}
        />
      </Box>
      <Flex justify="flex-end">
        <Button type="button" onClick={onCancel} style={{ marginRight: 4 }}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save
        </Button>
      </Flex>
    </form>
  );
});

class SalespersonCard extends React.Component {
  static propTypes = {
    franchiseId: PropTypes.any,
    salesperson: PropTypes.object,
    onSave: PropTypes.func.isRequired
  };

  state = {
    editing: false
  };

  save = values => {
    return this.props
      .onSave({
        ...values
      })
      .then(this.toggleEdit);
  };

  toggleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  renderForm() {
    const { salesperson, franchiseId } = this.props;
    return (
      <ChangeSalespersonForm
        initialValues={{ salespersonId: salesperson ? salesperson.id : null }}
        franchiseId={franchiseId}
        onSubmit={this.save}
        onCancel={this.toggleEdit}
      />
    );
  }

  render() {
    const { franchiseId, salesperson, onSave, ...otherProps } = this.props;
    const { editing } = this.state;
    return (
      <Panel {...otherProps}>
        <PanelHeader>
          <span>Salesperson</span>
          <Button
            onClick={this.toggleEdit}
            style={{ marginLeft: "auto" }}
            size="sm"
            disabled={editing}
          >
            {editing ? "Editing" : "Edit"}
          </Button>
        </PanelHeader>
        <PanelBody>
          {editing ? (
            this.renderForm()
          ) : (
            <UserInfo user={this.props.salesperson} label="Salesperson" />
          )}
        </PanelBody>
      </Panel>
    );
  }
}

export default SalespersonCard;



// WEBPACK FOOTER //
// ./src/components/job/SalespersonCard.js